import store from "@/store/index";

const getters = {
    /** User **/
    isLoggedIn: state => state.auth.api_token !== null,
    isGuest: state => state.auth.api_token === null || state.auth.api_token === undefined,
    token: state => state.auth.api_token,
    user: state => state.auth.user,
    patient: state => state.auth.patient,

    /** Common **/
    maintenanceMode: state => state.errors.maintenanceMode,
    limitError: state => state.errors.limitError,
    getPhone: state => state.auth.phone,
    personalDoctorId: state =>  state.auth.patient.personal_doctor_id,
    settings: state => state.settings.settings,
    doctors: state => state.settings.doctors,
    sliders: state => state.settings.sliders,
    clinics: state => state.settings.clinics,
    specializations: state => state.settings.specializations,
    diagnosticTypes: state => state.settings.diagnosticTypes,
    diagnostics: state => state.settings.diagnostics,
    language: state => state.settings.language,
    errors: state => state.errors,

    /** Visits **/
    visitCurrentCount: state => state.auth.patient.planed_visits_count || 0,
    isConsultationsInLoading: state => state.visits.visitsSpecialization.loading,
    isDiagnosticsInLoading: state => state.visits.visitsDiagnostic.loading,
    consultationsPastCount: state => state.visits.visitsSpecialization.data['CMP'] ? state.visits.visitsSpecialization.data['CMP'].length : 0,
    diagnosticsPastCount: state => state.visits.visitsDiagnostic.data['CMP'] ? state.visits.visitsDiagnostic.data['CMP'].length : 0,
    consultationsPast: state => state.visits.visitsSpecialization.data['CMP'] || [],
    diagnosticsPast: state => state.visits.visitsDiagnostic.data['CMP'] || [],
    consultationsCurrent: state => state.visits.visitsSpecialization.data['PLN'] || [],
    diagnosticsCurrent: state => state.visits.visitsDiagnostic.data['PLN'] || [],
    otherServicesCurrent: state => state.visits.visitsOtherServices.data['PLN'] || [],
    consultationsCurrentCount: state => state.visits.visitsSpecialization.data['PLN'] ? state.visits.visitsSpecialization.data['PLN'].length : 0,
    diagnosticsCurrentCount: state => state.visits.visitsDiagnostic.data['PLN'] ? state.visits.visitsDiagnostic.data['PLN'].length : 0,
    visitsOtherServicesCurrentCount: state => state.visits.visitsOtherServices.data['PLN'] ? state.visits.visitsOtherServices.data['PLN'].length : 0,

    /** Analyzes **/
    analyzesCount: state => state.auth.patient.analyzes_count || 0,
    analyzes: state => state.analyzes.analyzesList,
    analyzesChartList: state => state.analyzes.analyzesChartList,
    chartData: state => state.analyzes.chartData,
    selectedAnalyzeItem:state=>state.analyzes.selectedAnalyzeItem,

    /**Diagnostic Files**/
    diagnosticFiles: state => state.diagnosticFiles.diagnosticFilesList

}

export default getters
